module.exports = __webpack_public_path__ + "img/99ne.1c7cb61c.svg";